var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstallRemoval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(.994 .11 -.11 .994 -28.962 -29.776)",
    gradientUnits: "userSpaceOnUse",
    x1: 172.48,
    x2: 497.848,
    y1: 110.639,
    y2: 436.007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#ff8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#ff6c54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6359"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 490.487,
    x2: 466.43,
    y1: 159.015,
    y2: 164.322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2157,
    stopColor: "#b0e995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    stopColor: "#87e4bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    stopColor: "#6ee1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e0db"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(.983 -.185 .185 .983 55.608 42.369)",
    gradientUnits: "userSpaceOnUse",
    x1: 15.52,
    x2: 340.888,
    href: "#lg1",
    y1: 104.705,
    y2: 430.073
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#9ad57d",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    stopColor: "#51b482",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8679,
    stopColor: "#239f85",
    stopOpacity: 0.868
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119786"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.682,
    x2: 450.637,
    href: "#lg2",
    y1: 256.546,
    y2: 256.546
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.731,
    x2: 176.731,
    href: "#lg2",
    y1: 466.917,
    y2: 442.601
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.264,
    x2: 413.632,
    y1: 111.753,
    y2: 437.121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.768,
    x2: 430.112,
    y1: 101.155,
    y2: 514.021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    stopColor: "#2bb9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#42a0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.588,
    x2: 214.616,
    y1: 316.53,
    y2: 497.406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2154,
    stopColor: "#b0e995",
    stopOpacity: 0.784
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    stopColor: "#87e4bb",
    stopOpacity: 0.439
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8334,
    stopColor: "#6ee1d2",
    stopOpacity: 0.165
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    stopColor: "#65e0db",
    stopOpacity: 0
  }))), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.822,
    x2: 366.499,
    href: "#lg1",
    y1: 288.474,
    y2: 506.622
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.242,
    x2: 171.618,
    y1: 131.922,
    y2: 202.666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m426.926 470.539-386.877-42.878c-18.601-2.061-32.008-18.811-29.947-37.412l35.559-320.841c2.062-18.601 18.812-32.009 37.412-29.947l386.877 42.878c18.601 2.062 32.009 18.812 29.947 37.412l-35.559 320.841c-2.061 18.601-18.811 32.009-37.412 29.947z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.897 119.752-14.02 126.534-31.162-165.634 15.241 1.688c18.595 2.058 32 18.806 29.941 37.412z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.373 410.94-382.536 71.964c-18.392 3.46-36.107-8.645-39.567-27.037l-59.68-317.241c-3.46-18.392 8.645-36.107 27.037-39.567l382.536-71.964c18.392-3.46 36.107 8.645 39.567 27.037l59.68 317.241c3.46 18.393-8.645 36.108-27.037 39.567z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.896 97.546v317.999l24.476-4.605c18.392-3.46 30.497-21.175 27.037-39.567z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.45 446.187 1.821 9.68c3.46 18.392 21.175 30.497 39.567 27.037l195.175-36.717z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m424.01 448.166h-389.245c-18.715 0-33.886-15.171-33.886-33.886v-322.806c0-18.715 15.171-33.886 33.886-33.886h389.245c18.715 0 33.886 15.171 33.886 33.886v322.806c0 18.715-15.171 33.886-33.886 33.886z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.279 416.326h-325.782c-15.663 0-28.361-12.698-28.361-28.361v-270.175c0-15.663 12.698-28.361 28.361-28.361h325.782c15.663 0 28.361 12.698 28.361 28.361v270.175c0 15.663-12.698 28.361-28.361 28.361z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m252.069 416.326h-185.567c-15.666 0-28.37-12.694-28.37-28.359v-44.29l47.082-57.228c15.538-18.903 44.46-18.903 60.009 0l29.315 35.64z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.643 316.75v71.217c0 15.666-12.704 28.359-28.37 28.359h-295.268l77.532-94.237 95.246-115.783c15.538-18.892 44.471-18.892 60.009 0z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 137.225,
    cy: 157.919,
    fill: "url(#SVGID_10_)",
    r: 40.219
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallRemoval);
export default __webpack_public_path__ + "static/media/install-removal.499fea901aa7a58a069bb5b8bd5ee211.svg";
export { ForwardRef as ReactComponent };